import {
  SELECTOR_OPTIONS_GET_REQUEST,
  SELECTOR_OPTIONS_GET_SUCCESS,
  SELECTOR_OPTIONS_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { queryStringBuilder } from '../../../utils/helpers';

export function getSelectorOptions(endpoint, reduxIdentifier, callArgs) {
  return {
    types: [SELECTOR_OPTIONS_GET_REQUEST, SELECTOR_OPTIONS_GET_SUCCESS, SELECTOR_OPTIONS_GET_FAILURE],
    reduxIdentifier,
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: `v1/query/${endpoint}${callArgs ? queryStringBuilder(callArgs) : ''}`,
    }),
  };
}
